const getFileNameFromHeaders = (headers, fallbackName) => {
  const contentDisposition = headers.get("content-disposition") || "";
  const utf8Match = contentDisposition.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    return decodeURIComponent(utf8Match[1]);
  }

  const basicMatch = contentDisposition.match(/filename="?([^"]+)"?/i);
  return basicMatch?.[1] || fallbackName;
};

const apiBaseUrl =
  process.env.REACT_APP_API_BASE_URL || "https://devapi.sordiz.com";

const buildRequestUrl = (endpoint, params) => {
  const normalizedBase = apiBaseUrl.replace(/\/+$/, "");
  const normalizedEndpoint = endpoint.startsWith("/") ? endpoint : `/${endpoint}`;
  return `${normalizedBase}${normalizedEndpoint}${params.toString() ? `?${params.toString()}` : ""}`;
};

export const downloadFile = async ({
  endpoint,
  queryParams = {},
  token,
  fallbackFileName = "report.csv",
}) => {
  if (!token) {
    const error = new Error("Unauthorized");
    error.status = 401;
    throw error;
  }

  const params = new URLSearchParams();
  Object.entries(queryParams).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item !== undefined && item !== null && item !== "") {
          params.append(key, item);
        }
      });
      return;
    }
    params.append(key, String(value));
  });

  const requestUrl = buildRequestUrl(endpoint, params);
  const response = await fetch(requestUrl, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    let backendMessage = "";
    try {
      const contentType = (response.headers.get("content-type") || "").toLowerCase();
      if (contentType.includes("application/json")) {
        const payload = await response.json();
        backendMessage =
          payload?.detail || payload?.message || payload?.title || "";
      } else {
        const text = await response.text();
        backendMessage = text?.slice(0, 200) || "";
      }
    } catch (error) {
      backendMessage = "";
    }

    const errorMessage = backendMessage
      ? `Download failed: ${response.status} ${backendMessage}`
      : `Download failed: ${response.status}`;
    const error = new Error(errorMessage);
    error.status = response.status;
    error.requestUrl = requestUrl;
    throw error;
  }

  const blob = await response.blob();
  const fileName = getFileNameFromHeaders(response.headers, fallbackFileName);
  const blobUrl = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = blobUrl;
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(blobUrl);
};
